import React from 'react';
import {Col, Select} from "antd";
import defaultImage from './../assets/images/default.jpg';

const previewDefaultImage = (e) => {
	e.target.onerror = null;
	e.target.src = defaultImage;
};

const Dog = ({title, image, description, colProps, children}) => (
	<Col {...colProps}>
		<div className="content-box">
			<h3>{title}</h3>
			<img src={image} alt="#" onError={previewDefaultImage}/>
			{children}
			<p>{description}</p>
		</div>
	</Col>
);

export default Dog;